import {
  SET_USERINFO,
  SET_USER_MOBILE,
  SET_TO_LOGIN_AS_ADMIN,
  SET_PERMISSION
} from './mutation-types.js'
import { getCookie } from '@/assets/utils/CommonUtil'

export default {
  [SET_USERINFO] (state, user) {
    if (user) {
      state.user = user
    }
    if (!state.userInfoReady) {
      if (!user && state.user.userType === undefined) {
        const info = getCookie('ZJYUSERINFO')
        if (info) {
          state.user = JSON.parse(info)
        }
      }
      state.userInfoReady++
    }
  },
  [SET_TO_LOGIN_AS_ADMIN] (state) {
    state.toLoginAsAdmin++
  },
  [SET_USER_MOBILE] (state, passwordMobile) {
    if (passwordMobile) {
      state.user.passwordMobile = passwordMobile
    }
  },
  [SET_PERMISSION] (state, data) {
    state.permission = data
  }
}
